<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index">首頁</router-link></li>
            <li>服務條款</li>
          </ul>
        </div>
      </div>

      <!--服務條款開始-->
      <!-- <div class="headgraphic">
          <div class="container">
              <div class="wrapper">
                  <h1>服務條款</h1>
              </div>
          </div>
          <div class="image"><img src="images/graphic_policy.jpg" alt="服務條款視覺圖"></div>
      </div> -->

      <!--服務條款開始-->

      <div class="bodyContent">
        <div class="container">
          <section class="uploadArea p_mgin20">
            <div class="innerHeader">
              <h1>服務條款</h1>
            </div>

            <p>
              歡迎您使用「一刻鯨選」（以下簡稱我們、本服務、本平台）<br>
              「一刻鯨選」係由「聯合報股份有限公司」建置之網路資訊平台，請您詳細閱讀本服務條款，當您開始使用「一刻鯨選」服務時，即視為已知悉、並完全同意本服務條款所有約定。
            </p>
            <h2>1. 簡介</h2>
            <p>
              「一刻鯨選」供應經挑選的數位內容，您可以透過行動載具、電腦或其他受支援的載具（合稱「載具」），藉由註冊或其他方式使用「一刻鯨選」App 軟體應用程式以及網站，或是透過本服務瀏覽、尋找或下載數位內容。此處所謂「數位內容」，包括但不限於透過本平台以數位形式取得、收聽、檢視、播放或閱讀的資料檔案、文字、音頻或其他音效、相片、影片或其他圖片。
            </p>
            <h2>2. 購買與付款</h2>
            <div class="group_pList">
              <p>
                <strong>免費試聽。</strong>本平台提供部分數位內容免費試聽的服務，購買前請務必先行試聽，確認該數位內容符合您的需求後方行購買。
              </p>
            </div>
            <div class="group_pList">
              <p>
                <strong>購買點數。</strong>您可以透過本平台支援的付款方式購買點數，並且以點數取得收聽數位內容的權利。詳細支援的付款方式，請您參考<a href="/info" target="_blank">補充說明</a>。任何以違法或不正當方式取得點數之行為，本服務有權收回該點數。
              </p>
              <ol>
                <li>
                  一旦您在本平台下單購買本服務，即表示您同意所有在本平台所進行的交易行為皆以本平台之電子系統所記錄之電子交易資料為準，如有糾紛時，以該電子交易資料為認定標準。如您發現交易資料有誤，應立即通知我們。
                </li>
                <li>
                  您瞭解並同意，雖然本服務會盡力維護相關資料的正確性，但我們不以任何明示或默示的方式保證所有出現在網頁、App、或相關訊息上的資料均為完整、正確、即時的資訊。
                </li>
              </ol>
            </div>
            <div class="group_pList">
              <p>
                <a name="RequestRefund"></a><strong>退款政策。</strong>當您遇到退款問題，請您依照下述方式處理：
              </p>
              <ol>
                <li>
                  <strong>點數一經使用概不退換。</strong>本平台提供之服務，因數位智慧財產權之特性且為尊重及保護智慧財產權，數位服務的內容經您透過任一載具存取後，除有瑕疵，本公司將依法處理外，恕不接受解約退款。若您購買的點數從未使用，可申請退費但本公司將酌收行政處理費。相關退費之說明，請參閱<a href="/info" target="_blank">補充說明</a>。
                </li>
                <li>
                  <strong>不適用七天鑑賞期。</strong>本平台提供之服務屬於數位內容智慧財產權產品，且皆有提供用戶免費試聽內容，故不適用《消費者保護法》第十九條第一項規定之七天內解約權（七天鑑賞期）。（依據「通訊交易解除權合理例外情事適用準則」第二條）
                </li>
                <p>
                  如果本公司因任何理由，選擇將您購買價金退還給您，則您將無權再存取相關數位內容。
                </p>
                <li>
                  <strong>應用程式內購之退款。</strong>如果您透過Google Play 或 Apple的 App 內購買，請您參考並遵循該服務商之退款政策辦理。相關退款之說明，請參閱<a href="/info" target="_blank">補充說明</a>。
                </li>
                <li>
                  <strong>不當使用退款政策之處理。</strong>若您惡意或濫用我們的點數退款政策，我們保留權利可禁用您的帳戶，並限制未來對服務的所有使用。若您因違反本服務條款或本平台已公告之其他準則，使得我們禁用您的帳戶或停止您對本服務的所有存取權限，您將不具收到任何點數或退款的資格。
                </li>
              </ol>
            </div>
            <div class="group_pList">
              <p>
                <strong>服務瑕疵。</strong>當本服務提供給您收聽數位內容的權利後，您應於合理期間內儘快檢查數位內容，確認其是否可正確播放或下載。若您發現數位內容有任何錯誤或瑕疵而無法正常播放或下載，則應儘快通知本公司。若本服務無法如預期提供或呈現您所取得的數位內容，則在符合本服務條款所載任何限制（請參考本服務之退款政策）的前提下，本公司將會提供替換的數位內容或退還購買價金。
              </p>
            </div>
            <div class="group_pList">
              <p>
                <strong>移除數位內容或中止數位內容存取權。</strong>根據本服務條款，只要本公司持續有權將數位內容提供給您，您即可繼續透過本服務購買點數並享有存取數位內容的權利。在某些情況下（例如本公司喪失相關權利、中斷某項服務，或某項數位服務停止供應、或您違反適用條款或法規），本公司可能會從您的載具中移除您已取得的數位內容，或中止您對數位內容的存取權。本公司將盡可能以合理之方式，於上述移除數位內容或中止存取權之前通知您。
              </p>
            </div>
            <h2>3. 用戶權利與規範</h2>
            <p>
              <strong>用戶。</strong>是指所有使用本服務的使用者。為維護用戶的權利，本平台的部分功能或服務，需要您使用可被識別的身份驗證（包含但不限於udn會員、Facebook、Google帳號、手機號碼…等方式登入），我們才能提供適當服務（包含但不限於購買點數、透過點數而取得數位內容的權利，或其他功能等）。
            </p>
            <p>
              <strong>數位內容使用授權。</strong>本平台提供之數位內容係授權使用，而非出售賣斷。當您支付相關費用並取得收聽數位內容的權利後，您將擁有非專屬且不可轉讓、不可轉授權之權利，透過您的載具存取數位內容（不論以何種方式，皆只能依本公司透過本服務使用者介面明文允許之方法，並須遵守本服務條款所載之規範），或在您的載具上收聽、使用及顯示數位內容，並且僅供您個人為非商業用途之目的而收聽、使用及顯示數位內容。本服務和數位內容之一切權利、名義和利益，除本服務條款明文授予您者外，均由本公司及其授權人保留。
            </p>
            <p>
              <strong>更換載具。</strong>當您購買點數或透過點數而取得數位內容之使用權利時，需要驗證您的身份，在您更換裝置或裝置損壞、遺失時，可重新驗證您的身份，並在新的裝置取回您在本平台的點數以及數位內容收聽權利。相關說明請參閱<a href="/info" target="_blank">補充說明</a>。
            </p>
            <p>
              <strong>載具存取之限制。</strong>本公司得隨時自行決定，針對您可用來存取數位內容之載具數量進行限制或變更其數量，請參閱<a href="/info" target="_blank">補充說明</a>。我們可能會因法律有所要求等情況下，變更您先前購買點數之相關限制。您必須遵守所有這類限制。本公司得記錄並儲存您載具的唯一裝置識別碼，以便進行驗證及實施這類限制。如果您不同意本公司記錄並儲存這類資訊，則請勿使用本服務。
            </p>
            <p>
              <strong>您的個人相關資訊。</strong>為了讓您存取本服務，我們必須取得您的若干個人相關資訊，例如姓名、聯絡方式等。本公司的<a href="https://www.udngroup.com/members/udn_privacy" target="_blank">隱私權政策</a>會說明當您使用本服務時，我們會如何搜集、處理、使用您的個人資料並保護您的隱私權。若您不同意本公司的隱私權政策，請您勿使用本服務。您提供給本公司的任何這類資訊皆應一律正確無誤，並且符合您的現況。
            </p>
            <p>
              <strong>停用的帳戶。</strong>若本公司依據本服務條款停用您的帳戶存取權，您將無法自行存取本服務。
            </p>
            <p>
              <strong>停權或取消用戶資格。</strong>如果您在使用本服務時有違反任何法令、侵害他人任何權益、或者有違反本服務條款之任何規定，本公司有權立即停止您使用本服務的權利，或者取消您的用戶資格。
            </p>
            <div class="group_pList">
              <p>
                <strong>服務暫停或中斷。</strong>本服務系統或功能之例行性維護、改置或變動所發生之服務暫停或中斷，本服務將於該暫停或中斷前以App、公告或其他適當之方式告知您，您同意本公司不須因此負損害賠償責任。
              </p>
              <ol>
                <li>對本服務相關軟硬體設備進行搬遷、更換、升級、保養或維修時。</li>
                <li>您有任何違反政府法令或本使用條款情形時。</li>
                <li>天災或其他不可抗力所致之服務停止或中斷時。</li>
                <li>任何不可歸責於本公司之事由所致之服務停止或中斷時。</li>
              </ol>
            </div>
            <p>
              <strong>年齡限制。</strong>若您為未成年人，須在您的家長（或監護人）閱讀、瞭解並同意本服務條款之所有內容後，您才可使用本服務。當您開始使用或繼續使用本服務時，即表示您的家長（或監護人）已閱讀、瞭解並同意接受本服務條款之所有內容及其後之修改、變更。若您所在國家／地區的法律禁止您接收或使用本服務或任何數位內容，則請您勿存取本服務或者立即停止存取本服務。您必須遵守所有其他適用於規範本服務特定數位內容使用年齡的限制。
            </p>
            <p>
              <strong>基本使用需求。</strong>如要使用本服務，您必須擁有符合相關數位服務之系統和相容性需求的載具（系統和相容性需求可能隨時變更）、暢通的網際網路連線，以及相容軟體。這些因素皆可能影響您能否使用本服務以及本服務之效能。請自行注意您的軟硬體設備是否符合這類系統需求。
            </p>
            <p>
              <strong>第三方費用。</strong>您使用本服務時，可能會因此衍生第三方（例如，您的網際網路供應商或行動通訊業者）所收取之存取費用或資料傳輸費用。您必須自行負責支付所有相關費用。
            </p>
            <p>
              <strong>更新。</strong>您可能必須安裝我們不定期發佈的相關軟體更新，才能使用本服務及存取或下載數位內容。本服務可能會不時與本公司伺服器連線，檢查是否有可用的軟體更新或功能更新，例如錯誤修正、修補、增強功能、遺失的外掛程式和新版本等（合稱「更新」），並透過自動程序向您提出要求取得更新。您必須同意接收這類透過自動提出要求所取得的更新，才能使用本服務。如果您不同意這類透過自動提出要求而接收之更新，我們將不保證您能取得完整的服務。
            </p>
            <p>
              <strong>對第三方銷售、散佈或轉讓。</strong>您不得在未經授權的狀況下，將本服務之數位內容之全部或一部、或相關權利，販售、出租、出借、散佈、播送、傳輸（含張貼、轉貼、轉寄）、傳播、修改、改作、轉授權或移轉或轉讓給任何第三方。使用本服務所提供之任何工具或功能（例如社交網路推薦）時，只要完全依本服務所指定及開放之方式使用該工具，即不致違反本規定。
            </p>
            <p>
              <strong>共用。</strong>除非獲得本公司特別允許並僅完全依本服務所指定及開放之方式（例如社交網路推薦），否則您不得在任何共用、共享或多人使用之服務中，將本服務之數位內容用於任何其他機構（包括但不限於圖書館）之用途。
            </p>
            <p>
              <strong>兒童及青少年之保護。</strong>本服務依網站內容分級標準處理，若您未滿十八歲，不得購買及使用標示為限制級或「未滿十八歲者不得瀏覽」等之數位服務。若您未滿二十歲，依中華民國民法規定，未滿七歲之未成年人為交易行為時，應由家長（或法定代理人）代為行為並應全程在旁陪伴；七歲以上未滿二十歲之未成年人為交易行為時，應取得家長（或法定代理人）之同意。
            </p>
            <p>
              <strong>安全性功能。</strong>您不得試圖規避、停用或破解任何保護數位內容或本服務的任何安全性功能或元件（例如數位版權管理軟體或加密），或協助、授權或鼓勵他人為之。如果您侵犯任何安全性功能，可能會產生民事或刑事責任。
            </p>
            <h2>4. 數位內容保護與智慧財產權</h2>
            <p>
              <strong>數位內容保護。</strong>本服務將採取目前商業上通常使用且為技術上合理可行之數位內容保護機制，進行數位內容之權利管理電子資訊以及防盜拷措施之設定。但本公司不保證本服務或其數位內容必可免於遭受他人以任何手段不法移除、變更權利管理電子資訊、或者進行不法之侵入、破壞、複製或破解、規避防盜拷措施。
            </p>
            <p>
              <strong>智慧財產權保護。</strong>本服務中由本公司自行製作或經合法授權而公開傳輸的所有內容，包括但不限於文字、照片、影像、插圖、音樂、錄音、影音、檔案、網站畫面的安排、網頁設計等素材，均受到中華民國著作權法及國際著作權相關條約的保障。
            </p>
            <p>本服務數位內容僅供已獲得授權之用戶使用，並非將數位內容之所有權或智慧財產權移轉給您，一切本公司沒有在本服務條款中明確授予您的權利，均由本公司或原權利人保留依法擁有之智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。
            </p>
            <p>您不得移除或變更本服務之數位內容中所包含的任何權利管理電子資訊，包括但不限於任何浮水印、文字標示、著作權標示、商標權標示或其他法律或專屬權利聲明，亦不得嘗試修改任何透過本服務取得之數位內容的標題、形式或內容，包括為掩飾或變更數位服務之任何所有權或來源標示所做之修改。
            </p>
            <p>若您欲引用、複製或轉載、轉貼、轉寄本服務之數位內容或網站內容，必須依法取得本公司或其他權利人的事前書面同意，否則您應自負法律責任，並賠償本公司或其他權利人因此所生之一切損害，包括但不限於律師費、訴訟費、和解金等。
            </p>
            <p>
              <strong>本服務條款之變更。</strong>本服務條款如有變更，則在您下次使用本服務之前，系統會請您接受新服務條款。您接受新服務條款後，您對所有本服務（包括您過去所購買的點數）之使用以及後續所取得的數位內容權利，即適用新服務條款，直到本公司通知您進一步變更為止。若您在本公司修改本服務條款後仍繼續使用本服務，即代表您已接受此修改條款之規範。
            </p>
            <p>
              <strong>準據法與管轄法院。</strong>您同意因本服務條款或本平台所衍生或相關之任何爭議，除法律另有規定者外，均應依照中華民國法律予以處理，並以台灣臺北地方法院為第一審管轄法院。
            </p>
          </section>
        </div>
      </div>

      <!--服務條款結束-->

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'async',
  metaInfo () {
    return {

      title: '服務條款 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '服務條款 | 一刻鯨選' },
        { property: 'og:site_name', content: '服務條款 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '「一刻鯨選」係由「聯合報股份有限公司」建置之網路資訊平台，請您詳細閱讀本服務條款，當您開始使用「一刻鯨選」服務時，即視為已知悉、並完全同意本服務條款所有約定。' }

      ]
    }
  },

  data () {
    return {
      classData: []
    }
  },
  methods: {

    changePage (page) {
      this.$router.push({ path: '/' + page })
    }

  },
  mounted () {
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Terms.vue